<script lang="ts" setup>
	interface Props {
		textToCopy?: string
		chunkSize?: number
		dir?: 'ltr' | 'rtl'
		iconSize?: number
	}
	const props = defineProps<Props>()

	const { copyText } = useCopy()

	const copyEl = ref<null | HTMLElement>(null)
	const slicedText = shallowRef('')
	const rawText = shallowRef('')
	const copyItem = () => {
		if (props.textToCopy === 'n/a') return useNotification().alert({ status: 400, message: 'Item not available' })
		if (props.textToCopy || rawText.value) return copyText(props.textToCopy || rawText.value)

		if (copyEl.value || rawText.value) {
			const text = copyEl.value?.innerText ?? rawText.value
			if (text) copyText(text)
		} else {
			useNotification().alert({ status: 500, message: 'Something went wrong copying.' })
		}
	}
	const setText = () => {
		if (props.textToCopy) {
			rawText.value = props.textToCopy
			return (slicedText.value = String(props.textToCopy).slice(0, props.chunkSize ?? 8))
		}
		if (copyEl.value) {
			const text = copyEl.value.innerText ?? ''
			rawText.value = text
			return (slicedText.value = text.slice(0, props.chunkSize ?? 8))
		}
	}

	watch(() => props.textToCopy, setText)
	onMount(setText)
</script>

<template>
	<div>
		<a-tooltip title="Click to copy" size="small" class="relative" placement="top">
			<div
				class="no-select flex items-center gap-1"
				:class="[dir === 'rtl' ? 'flex-row-reverse' : '']"
				role="button"
				@click="copyItem"
			>
				<slot name="icon">
					<tools-icon dir="fill" icon="copy" :height="iconSize ?? 20" :width="iconSize ?? 20" />
				</slot>
				<span v-if="!rawText" ref="copyEl" role="button" name="copy button">
					<slot>
						{{ textToCopy }}
					</slot>
				</span>
				<span v-else :data-id="rawText" class="truncate">
					<slot>
						{{ slicedText }}
					</slot>
				</span>
			</div>
		</a-tooltip>
	</div>
</template>
